<template>
    <div class="container">
        <router-view></router-view>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'users',
        created() {
            this.GetAllUsers();
        },
        methods: {
            ...mapActions([
                'GetAllUsers'
            ])
        }
    }
</script>